var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.633,
    height: 60,
    viewBox: "0 0 94.633 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-1664.899 -41)",
    fontFamily: "Droid Arabic Kufi"
  }, /*#__PURE__*/React.createElement("path", {
    id: "yes_1_.svg_Recovered_",
    d: "M171.643,188.187c-5.316-2.8-6.3-7.108-5.371-12.151a18.786,18.786,0,0,0-2.64.018,7.782,7.782,0,0,1-7.944-3.22,6.188,6.188,0,0,1-.055-7.425,8.8,8.8,0,0,1,.672-.8l.084-.092-.106.066c-.246.162-.455.369-.712.51a.71.71,0,0,1-.349.122c-3.007.244-3.972-.934-3.638-4.261,0,0,.062-.506.073-.613l-.275.447c-1.252,1.846-1.1,3.39.631,4.759.283.222.668.4.822.687a5.557,5.557,0,0,1-.132,5.631c-1.219,1.769-2.5,4.084-5.206,4.18-1.92.066-3.844,0-6.193,0,1.509,5.42-.341,9.3-5.1,12.3,5.092,2.828,6.347,6.964,5.246,12.111h6.4V220.34H159.6V200.483h6.74C165.1,195.229,166.68,191.175,171.643,188.187Zm-23.4,3.578a23.432,23.432,0,0,0-.07,4.77,4.746,4.746,0,0,1-2.632.1c-.525-1.51.264-3.271-.367-4.626s-2-2.411-3.172-3.737c1.065-1.17,2.57-2.215,3.128-3.611s.117-3.113.117-4.6a4.713,4.713,0,0,1,2.908-.155c-.521,3.238.158,6.144,3.146,7.964C150.476,189.572,148.593,190.207,148.247,191.765Zm8.018,24.222h-4.347V203.045l2.2,1.754,2.177-1.743Zm-2.346-15.877c-3.4-2.215-3.447-6.078-.125-9.094,3.535,2.43,3.59,6.672.139,9.076Zm-.029-14.858c-3.418-2.426-3.421-6.45,0-8.8,3.454,2.341,3.458,6.388.015,8.791Zm8.737,11.25a4.812,4.812,0,0,1-3.014.026,24.412,24.412,0,0,0-.066-4.66c-.312-1.6-2.14-2.274-3.058-3.943a7.186,7.186,0,0,0,3.109-7.916,4.792,4.792,0,0,1,2.9-.107c-.466,3.294.062,6.325,3.774,8.234-3.073,2.19-4.644,4.774-3.627,8.359Z",
    transform: "translate(1587.889 -119.34)",
    fill: "#d2ba7c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    transform: "translate(1664.899 48.75)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u0633\\u0628\\u0642",
    transform: "translate(28 29)",
    fill: "#d2ba7c",
    fontSize: 23,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27,
    y: 0
  }, "\u0633\u0628\u0642")), /*#__PURE__*/React.createElement("text", {
    id: "\\u0644\\u0644\\u0645\\u0633\\u0627\\u0628\\u0642\\u0627\\u062A_\\u0648\\u0627\\u0644\\u0645\\u0646\\u0627\\u0641\\u0633\\u0627\\u062A",
    transform: "translate(28.857 46.178)",
    fill: "#d2ba7c",
    fontSize: 5
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24,
    y: 0
  }, "\u0644\u0644\u0645\u0633\u0627\u0628\u0642\u0627\u062A \u0648\u0627\u0644\u0645\u0646\u0627\u0641\u0633\u0627\u062A"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3999228309d3796680337d870297cdf4.svg";
export { ForwardRef as ReactComponent };